function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState, useEffect } from 'react';
import { scrollToElementCMS } from './scrollToElementCMS.js';
import { getNode } from './getNode.js';
import useContentMethods from './useContentMethods';
import useFormMethods from './useFormMethods';
import { useTranslator } from '../Translation/Translator';
import SIAPage from '../../components/SIA-WEBSITE/SIAPage/SIAPage';
import SIALegalPolicy from '../../components/SIA-WEBSITE/SIALegalPolicy/SIALegalPolicy';
import SIAArticle from '../../components/SIA-WEBSITE/SIAArticle/SIAArticle';
import SIAVacancy from '../../components/SIA-WEBSITE/SIAVacancy/SIAVacancy';
import SIANewsletter from '../../components/SIA-WEBSITE/SIANewsletter/SIANewsletter';
import SIAInformNewsletter from '../../components/SIA-WEBSITE/SIAInformNewsletter/SIAInformNewsletter';
import SIAHomepage from '../../components/SIA-WEBSITE/SIAHomepage/SIAHomepage';
import SIAFAQ from '../../components/SIA-WEBSITE/SIAFAQ/SIAFAQ';
import SIAConfirmationPage from '../../components/SIA-WEBSITE/SIAConfirmationPage/SIAConfirmationPage';
import SIAMasterpreisHomepage from '../../components/SIA-Masterpreis/SIAMasterpreisHomepage/SIAMasterpreisHomepage.js';
import SIAMasterarbeit from '../../components/SIA-Masterpreis/SIAMasterarbeit/SIAMasterarbeit.js';
const CMSContentWrapper = ({
  cmsAdapter,
  history,
  languageKey,
  nodeId,
  isHash,
  menuItems,
  noMenuPages,
  allowedCTs,
  isMasterpreisHomePage = false,
  browserTitle
}) => {
  const alias = history.location.pathname.replace(`/${languageKey}/cms/`, '').replace('hash/', '');
  const [isLoading, setIsLoading] = useState(true);
  const [siaContentProps, setSiaContentProps] = useState({});
  const [cachedValues, setCachedValues] = useState({});
  const [contentType, setContentType] = useState('');
  const translate = useTranslator();
  const node_id = React.useMemo(() => {
    return nodeId || getNode({
      alias,
      history,
      languageKey,
      menuItems,
      noMenuPages
    });
  }, [nodeId, alias, history, languageKey, menuItems, noMenuPages]);
  const {
    getContentByHash,
    getContentByNodeID,
    getMasterpreisHomepage
  } = useContentMethods(cmsAdapter, languageKey, history, setContentType, setSiaContentProps, setIsLoading, node_id, alias);
  const {
    fetchForm,
    onSubmitForm,
    fetchTerms
  } = useFormMethods(cmsAdapter, cachedValues, setCachedValues);
  const getAgenda = (onSuccess, events_number) => {
    cmsAdapter.fetchAgenda(languageKey, onSuccess, translate, events_number);
  };
  const getParagraph = (onSuccess, languageKey, id) => {
    cmsAdapter.fetchParagraph(onSuccess, languageKey, id);
  };
  const getMasterpreisArticles = async () => {
    return await cmsAdapter.fetchMasterpreisArticles(languageKey);
  };
  const agendaInformUrl = `/${languageKey}/agenda?organisators=464`;
  const loadPage = async () => {
    setIsLoading(true);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    if (isHash) return getContentByHash();
    if (isMasterpreisHomePage) {
      return getMasterpreisHomepage();
    }
    if (node_id > 0) return getContentByNodeID();else if (node_id !== -1) history.push(`/not-found`);
  };
  useEffect(() => {
    !isLoading && scrollToElementCMS(history);
    // eslint-disable-next-line
  }, [isLoading]);
  useEffect(() => {
    (alias || nodeId) && loadPage();
    // eslint-disable-next-line
  }, [alias, nodeId]);
  useEffect(() => {
    const createBrowserTitle = () => {
      if (browserTitle) return browserTitle;
      const newBrowserTitle = translate('browser.title');
      if (siaContentProps.title) {
        return `${siaContentProps.title} - ${newBrowserTitle}`;
      }
      return newBrowserTitle;
    };
    document.title = createBrowserTitle();
  }, [siaContentProps.title, translate, browserTitle]);
  if (isLoading) return /*#__PURE__*/React.createElement(React.Fragment, null);
  if (allowedCTs && !allowedCTs.includes(contentType)) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement("div", null, (contentType === 'sia_page' || contentType === 'sektion_page') && /*#__PURE__*/React.createElement(SIAPage, _extends({
    translate: (value, options) => translate(value, options),
    key: siaContentProps?.title
  }, siaContentProps, {
    lang: languageKey,
    history: history,
    inFormMethods: {
      fetchForm,
      onSubmitForm,
      fetchTerms,
      fetchNode: (languageKey, node_id, onSuccess) => cmsAdapter.fetchNode(languageKey, node_id, onSuccess)
    },
    captchaKey: process.env.REACT_APP_CAPTCHA_KEY,
    getParagraph: getParagraph
  })), contentType === 'sia_legalpolicy' && /*#__PURE__*/React.createElement(SIALegalPolicy, _extends({
    translate: (value, options) => translate(value, options),
    key: siaContentProps?.title
  }, siaContentProps, {
    history: history,
    lang: languageKey
  })), contentType === 'sia_article' && /*#__PURE__*/React.createElement(SIAArticle, {
    translate: (value, options) => translate(value, options),
    lang: languageKey,
    item: siaContentProps.item,
    history: history
  }), contentType === 'masterpreis_article' && /*#__PURE__*/React.createElement(SIAArticle, {
    translate: (value, options) => translate(value, options),
    lang: languageKey,
    item: siaContentProps.item,
    history: history,
    showModal: true
  }), contentType === 'masterarbeit' && /*#__PURE__*/React.createElement(SIAMasterarbeit, {
    translate: (value, options) => translate(value, options),
    lang: languageKey,
    item: siaContentProps.item,
    history: history,
    cmsAdapter: cmsAdapter
  }), contentType === 'sia_vacancies' && /*#__PURE__*/React.createElement(SIAVacancy, {
    translate: (value, options) => translate(value, options),
    lang: languageKey,
    item: siaContentProps.item,
    history: history
  }), contentType === 'sia_newsletter' && /*#__PURE__*/React.createElement(SIANewsletter, {
    translate: (value, options) => translate(value, options),
    lang: languageKey,
    item: siaContentProps.item,
    history: history
  }), contentType === 'sia_inform_newsletter' && /*#__PURE__*/React.createElement(SIAInformNewsletter, {
    lang: languageKey,
    item: siaContentProps.item,
    translate: translate,
    agendaInformUrl: agendaInformUrl
  }), contentType === 'homepage' && /*#__PURE__*/React.createElement(SIAHomepage, {
    translate: (value, options) => translate(value, options),
    lang: languageKey,
    item: siaContentProps.item,
    history: history,
    getAgenda: getAgenda
  }), contentType === 'masterpreis_homepage' && /*#__PURE__*/React.createElement(SIAMasterpreisHomepage, {
    translate: (value, options) => translate(value, options),
    lang: languageKey,
    item: siaContentProps.item,
    history: history,
    getMasterpreisArticles: getMasterpreisArticles
  }), contentType === 'sia_faq' && /*#__PURE__*/React.createElement(SIAFAQ, _extends({
    translate: (value, options) => translate(value, options)
  }, siaContentProps.item, {
    lang: languageKey,
    history: history,
    inFormMethods: {
      fetchForm,
      onSubmitForm
    },
    captchaKey: process.env.REACT_APP_CAPTCHA_KEY,
    getParagraph: getParagraph
  })), contentType === 'confirmation_page' && /*#__PURE__*/React.createElement(SIAConfirmationPage, _extends({}, siaContentProps.item, {
    lang: languageKey
  })), contentType === 'event' && /*#__PURE__*/React.createElement("div", {
    className: "sia-padding-04"
  }, /*#__PURE__*/React.createElement("h2", null, "TODO: Content type ", /*#__PURE__*/React.createElement("b", null, "event")), /*#__PURE__*/React.createElement("h2", null, siaContentProps.item.title)));
};
export default CMSContentWrapper;